import { FC } from 'react';
import cn from 'classnames';

import { addCommaForThousands } from 'lib/text.service';

import styles from './PsychicCardReadings.module.scss';

import type { IPsychicCardReadings } from '../config/declarations';

export const PsychicCardReadings: FC<IPsychicCardReadings> = ({
  psychic,
  className,
  psychicFrame,
}) => (
  <span className={cn(styles.readings, className)}>
    {`${psychicFrame.totalReadings}: ${addCommaForThousands(psychic.totalReadings || 0)} ${psychicFrame.since} ${psychic.serviceStartYear}`}
  </span>
);
